import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { CandidateJobStatus } from '@shared/models';

import { conductHiringManagerCandidateActionSuccess, loadCandidateHiringManagerStatusSuccess } from './hiring-manager-status.actions';

const selectId = (status: CandidateJobStatus) => `${status.jobId}:${status.candidateId}`;

export const hiringManagerStatusAdapter: EntityAdapter<CandidateJobStatus> = createEntityAdapter<CandidateJobStatus>({
  selectId,
  sortComparer: false,
});

export type HiringManagerStatusState = EntityState<CandidateJobStatus>;

export const initialState: HiringManagerStatusState = hiringManagerStatusAdapter.getInitialState({});

const reducer = createReducer(
  initialState,
  on(loadCandidateHiringManagerStatusSuccess, (state, { statuses }) => hiringManagerStatusAdapter.upsertMany(statuses, state)),
  on(conductHiringManagerCandidateActionSuccess, (state, { hiringManagerStatus }) =>
    hiringManagerStatusAdapter.upsertOne(hiringManagerStatus, state),
  ),
);

export function hiringManagerStatusReducer(state: HiringManagerStatusState, action) {
  return reducer(state, action);
}
